import React from 'react';
import { Option, IntegrationField } from 'api/integrations';
import { Task } from 'data/tasks';
import {
  IntegrationInputField,
  IntegrationMultiSelectField,
  IntegrationNumberField,
  IntegrationSelectField,
  IntegrationDateField,
} from '../../fields';
import { IntegrationMultiLineField } from '../../fields/multi-line-input-field';
import { filterableFieldType, IntegrationFieldType } from './get-field-type';

export const convertFieldOptionToSelect = (field: IntegrationField) =>
  (field.metaData?.options || []).map((option) => ({
    value: option.valueStr,
    ...option,
  }));

export const generateFormFields = (
  field: IntegrationField,
  options: Option[],
  disabled?: boolean,
  task?: Task,
) => {
  switch (filterableFieldType(field)) {
    case IntegrationFieldType.Text:
    case IntegrationFieldType.Summary: {
      return (
        <IntegrationInputField field={field} value={field.metaData?.default} />
      );
    }

    case IntegrationFieldType.TextArea:
    case IntegrationFieldType.Description: {
      return (
        <IntegrationMultiLineField
          field={field}
          value={field.metaData?.default}
        />
      );
    }

    case IntegrationFieldType.SingleSelect: {
      return (
        <IntegrationSelectField
          field={field}
          value={field.metaData?.default ?? ''}
          options={options}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.MultiSelect: {
      return (
        <IntegrationMultiSelectField
          field={field}
          value={field?.metaData?.default ?? []}
          options={options}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.Date: {
      const value =
        field.integrationFieldId === 'duedate' && task && task.dueDate
          ? Math.round(new Date(task.dueDate).getTime())
          : field.metaData?.default;

      return (
        <IntegrationDateField
          fieldValue={value}
          field={field}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.Number: {
      return (
        <IntegrationNumberField
          field={field}
          value={field?.metaData?.default ?? ''}
          disabled={disabled}
        />
      );
    }

    default: {
      return <></>;
    }
  }
};
